<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-proyecciones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="false"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @first-data-rendered="onFirstDataRendered"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>

<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { aMonedaValueFormatter, cellRendererNumeroRegistro, formatearValorAMoneda } from '../utils';

export default {
  name: 'ListadoPresupuestoProyeccionIngreso',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      selectedRows: [],
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CÓDIGO',
          field: 'programa.codigo',
          filter: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'NOMBRE DEL PROGRAMA',
          field: 'programa.nombre',
          filter: false,
          minWidth: 380,
        },
        {
          headerName: 'ENERO',
          field: 'enero.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'FEBRERO',
          field: 'febrero.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'MARZO',
          field: 'marzo.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'ABRIL',
          field: 'abril.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'MAYO',
          field: 'mayo.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'JUNIO',
          field: 'junio.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'JULIO',
          field: 'julio.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'AGOSTO',
          field: 'agosto.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'SEPTIEMBRE',
          field: 'septiembre.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'OCTUBRE',
          field: 'octubre.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'NOVIEMBRE',
          field: 'noviembre.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'DICIEMBRE',
          field: 'diciembre.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
        {
          headerName: 'TOTAL',
          field: 'total.total',
          type: 'numericColumn',
          valueFormatter: aMonedaValueFormatter,
          filter: false,
          minWidth: 95,
          maxWidth: 95,
        },
      ],
    };
  },
  created: function () {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  computed: {
    pinnedBottomRowData() {
      if (this.items.length <= 0) {
        return [];
      }

      const totales = {};

      this.items.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== 'programa') {
            if (totales[key]) {
              totales[key].total += item[key].total;
            } else {
              totales[key] = {};
              totales[key].total = item[key].total;
            }
          }
        });
      });

      return [
        {
          programa: {
            nombre: 'TOTALES',
          },
          enero: {
            total: formatearValorAMoneda(totales.enero.total),
          },
          febrero: {
            total: formatearValorAMoneda(totales.febrero.total),
          },
          marzo: {
            total: formatearValorAMoneda(totales.marzo.total),
          },
          abril: {
            total: formatearValorAMoneda(totales.abril.total),
          },
          mayo: {
            total: formatearValorAMoneda(totales.mayo.total),
          },
          junio: {
            total: formatearValorAMoneda(totales.junio.total),
          },
          julio: {
            total: formatearValorAMoneda(totales.julio.total),
          },
          agosto: {
            total: formatearValorAMoneda(totales.agosto.total),
          },
          septiembre: {
            total: formatearValorAMoneda(totales.septiembre.total),
          },
          octubre: {
            total: formatearValorAMoneda(totales.octubre.total),
          },
          noviembre: {
            total: formatearValorAMoneda(totales.noviembre.total),
          },
          diciembre: {
            total: formatearValorAMoneda(totales.diciembre.total),
          },
          total: {
            total: formatearValorAMoneda(totales.total.total),
          },
        },
      ];
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-proyecciones {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}

.ag-cell:nth-child(3) .ag-cell-wrapper {
  display: block;
}
</style>
